import React from 'react';
import { Input } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';

export default function ReposicaoTab({ dados, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <Secao titulo="Níveis de Reposição">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
          <Input label="Estoque Mínimo" type="number" step="0.01" value={dados.estoque_minimo || ''} onChange={e => onChange('estoque_minimo', e.target.value)} />
          <Input label="Estoque Máximo" type="number" step="0.01" value={dados.estoque_maximo || ''} onChange={e => onChange('estoque_maximo', e.target.value)} />
          <Input label="Prazo de Entrega (dias)" type="number" value={dados.prazo_entrega_dias || ''} onChange={e => onChange('prazo_entrega_dias', e.target.value)} />
          <Input label="Prazo de Validade (dias)" type="number" value={dados.prazo_validade_dias || ''} onChange={e => onChange('prazo_validade_dias', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Última Compra / Estoque Atual">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
          <Input label="Preço Última Compra" value={dados.preco_ultima_compra ?? '-'} disabled />
          <Input label="Data Última Compra" value={dados.data_ultima_compra ?? '-'} disabled />
          <Input label="Custo de Produção" type="number" step="0.01" value={dados.custo_producao || ''} onChange={e => onChange('custo_producao', e.target.value)} />
          <Input label="Estoque Atual" value={dados.estoque_atual_cache ?? '0'} disabled />
        </div>
      </Secao>
    </div>
  );
}
